export default __webpack_public_path__ + "static/404-comet-51905ff90adcda8324720e8b01d6c15c.svg";